import { useContext } from "react";
import { ShopifyContext } from "../context/ShopifyProvider";

export default function useProductImageVariant() {
  const { store } = useContext(ShopifyContext);

  const getVariantImage = ({ product, variantId }) => {
    if (product) {
      const foundVariant = product.variants.filter(
        (variant) => variant.storefrontId === variantId
      );
      return foundVariant[0].image;
    }
  };

  return {
    getVariantImage,
  };
}
